import capitalize from 'lodash/capitalize.js';

class NotificationService {
    constructor() {
        this.app = null;
    }

    install(app) {
        this.app = app;
        app.config.globalProperties.$edverumNotification = this;
    }

    /**
     * Open a notification.
     * Compatible with Buefy's notification signature.
     *
     * @param {Object} params
     * @param {string} params.message - The message to display
     * @param {string} [params.type] - 'is-success', 'is-danger', 'is-warning', 'is-info'
     * @param {string} [params.position] - 'is-top-right', 'is-top-left', 'is-bottom-right', 'is-bottom-left'
     * @param {number} [params.duration] - Duration in ms (default: 2000)
     * @param {boolean} [params.indefinite] - If true, stays until closed
     * @param {boolean} [params.queue] - If false, clears previous notifications
     * @param {boolean} [params.hasIcon] - Show icon based on type
     */
    open(params) {
        if (this.app) {
            const $primeToast = this.app.config.globalProperties.$toast;
            if ($primeToast) {
                return this.openPrimeVueToast(params);
            }
        }

        console.warn('PrimeVue toast service is not available.');
        return { close: () => {} };
    }

    openPrimeVueToast(params) {
        const $toast = this.app.config.globalProperties.$toast;

        const severityMap = {
            'is-success': 'success',
            'is-danger': 'error',
            'is-warning': 'warn',
            'is-info': 'info',
        };

        const severity = severityMap[params.type] || 'info';
        const life = params.indefinite ? 365 * 24 * 60 * 60 * 1000 : params.duration || 2000;

        const positionMap = {
            'is-top-right': 'top-right',
            'is-top-left': 'top-left',
            'is-bottom-right': 'bottom-right',
            'is-bottom-left': 'bottom-left',
        };

        const group = positionMap[params.position] || 'top-right';

        const message = {
            severity: severity,
            summary: capitalize(severity),
            detail: params.message,
            life: life,
            group: group,
        };

        $toast.add(message);

        return {
            close: () => {
                $toast.remove(message);
            },
        };
    }
}

const notificationService = new NotificationService();
export default notificationService;
